<template>
    <div class="float-left mr-1">
        <i
            class="fa fa-exclamation fa-lg icon-button"
            title="Pendência"
            @click.stop="abrirModal()">
        </i>
        <b-modal
            id="modalInserirDocumento"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
            no-enforce-focus>
            <div slot="modal-title">
                Pendência do Documento
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="5">
                    <b-form-group>
                        <label>Data da Pendência</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="documento.dataPendenciaFormatada"
                                disabled>
                            </b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="5">
                    <b-form-group v-if="documento.dataBaixaPendencia">
                        <label>Data da baixa da Pendência</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="documento.dataBaixaPendenciaFormatada"
                                disabled>
                            </b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2"
                    class="text-success text-right">
                    <i
                        v-if="documento.status == 1 || documento.status == 2"
                        class="fa fa-refresh fa-lg icon-button"
                        title="Resetar Pendência"
                        @click.stop="resetarPendencia(data)">
                    </i>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Qual a Pendência deste documento?</label>
                        <b-form-textarea
                            :rows="4"
                            v-model="pendencia"
                            v-if="!documento.pendencia">
                        </b-form-textarea>
                        <b-form-textarea
                            :rows="4"
                            v-model="documento.pendencia"
                            disabled
                            v-else>
                        </b-form-textarea>
                        <b-form-invalid-feedback>A justificativa da pendência do documento é obrigatória</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    class="ml-1"
                    @click.stop="salvarPendencia()"
                    :disabled="this.$v.$invalid">
                    Salvar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        documento: {
            type: Object,
            default: () => ({})
        },
    },

    validations: {
        pendencia: { required },
    },

    data() {
        return {
            mostrarModal: false,
            pendencia: null,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.resetar()
        },

        resetar(){
            this.pendencia = null
        },

        salvarPendencia() {
            let documento = {
                idConvenio: this.documento.id_Convenio,
                idDocumento: this.documento.id_Documento,
                pendencia: this.pendencia,
            }
            this.$store.dispatch('addRequest')
            ConveniosServicos.inserirPendenciaDocumento(documento)
                .then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Pendência salva com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },

        resetarPendencia() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.resetarPendenciaDocumento(this.documento.id_Documento)
                .then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Pendência resetada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                    } else {
                        this.$toast.error(
                            'Erro ao resetar pendência!',
                            'OK',
                            this.$toastConfig.error
                        )
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        }
    }
}
</script>
